import { Link } from "react-router-dom";
import { statsData } from "@/mocks/comics";

export default function StatsSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="lg:w-2/5">
            <span className="inline-block text-xs font-medium text-foreground-500 border border-background-300 rounded-full px-3 py-1 mb-6">关于我们</span>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
              为爱漫画的你
            </h2>
            <h3 className="text-3xl md:text-4xl font-light text-foreground-600 mb-8" style={{ fontFamily: "var(--font-heading)" }}>
              打造最好的阅读平台
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-md">
              韩漫屋汇聚了来自韩国的海量正版漫画资源，从经典名作到最新连载，覆盖恋爱、校园、奇幻、武侠等多元题材。我们坚持免费正版，让每一位读者都能畅享高品质的漫画阅读体验。
            </p>
            <Link to="/about" className="text-sm font-medium text-foreground-900 underline underline-offset-4 hover:text-accent-500 transition-colors">
              了解更多关于我们 →
            </Link>
          </div>

          <div className="lg:w-3/5 flex items-center">
            <div className="grid grid-cols-2 gap-6 md:gap-8 w-full">
              {statsData.map((stat) => (
                <div key={stat.label} className="text-center md:text-right">
                  <p className="text-4xl md:text-5xl font-bold text-foreground-950 mb-1" style={{ fontFamily: "var(--font-heading)" }}>
                    {stat.value}
                  </p>
                  <p className="text-sm text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
            <div className="hidden lg:block relative ml-8 w-64 h-80 flex-shrink-0">
              <div className="absolute top-0 left-0 w-40 h-40 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20reading%20app%20interface%20on%20phone%20screen%2C%20colorful%20comic%20thumbnails%20display%2C%20modern%20clean%20UI%20design%2C%20warm%20lighting%2C%20cozy%20reading%20atmosphere%2C%20minimal%20background&width=400&height=400&seq=stats-img-01&orientation=squarish"
                  alt="韩漫屋阅读界面展示"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute bottom-4 right-0 w-48 h-60 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20comic%20page%20display%20on%20tablet%20screen%2C%20beautiful%20romance%20illustration%2C%20vertical%20scroll%20layout%2C%20soft%20colors%2C%20digital%20reading%20experience%2C%20clean%20minimal%20background&width=480&height=600&seq=stats-img-02&orientation=portrait"
                  alt="韩漫屋漫画阅读展示"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}